module.exports = __webpack_public_path__ + "img/3.a85a52b5.jpg";